<template>
<div :id="'J_prismPlayer'+idName" />
</template>

<script>
/* eslint-disable */

export default {
    name: "videoraasplayer",
    props: {
        value: {
            type: [String],
            default: ""
        },
        idName: {
            type:Number,
            default:0
        },
        isOrder:{
            type:Number,
            default:0
        }
    },

    data() {
        return {
            player: null,
        };
    },
    mounted() {
    },
    methods: {
        dispose() {
            console.log('音频关闭')
            // 关闭窗口  关闭播放。
            this.player.dispose();
        },
        initPlayer(source,sourceSign,params) {
            // console.log(source, 'source',params)
            Aliplayer.__unable2Anti9Debugger13Key = 'error'; 
             if(sourceSign){
                let player2 = new Aliplayer({
                    "id": "J_prismPlayer"+this.idName,
                    "source": source,
                    "width": "100%",
                    "height": "600px",
                    "autoplay": false,
                    "isLive": false,
                    "rePlay": false,
                    "playsinline": true,
                    "preload": false,
                    "controlBarVisibility": "hover",
                    "useH5Prism": true
                },  player2 => {
                        //判断视频和音频获取对应标签
                        if(!this.isOrder){
                            var video = document.getElementById('J_prismPlayer'+this.idName).getElementsByTagName('video')[0]
                            // console.log(video)
                            var timeDisplay
                            var tryTime
                            var percent
                            //点击开始事件
                            video.addEventListener('play', ()=> {
                                //获取当前播放的时间指针
                                timeDisplay = Math.floor(video.currentTime);
                                //试看百分比
                                percent = parseFloat(params.watchPercent/100);
                                //可试看时间
                                tryTime = parseInt(params.duration*percent);
                                // console.log('timeDisplay----',timeDisplay,'tryTime----',tryTime,'this.player._vodDuration----',this.player._vodDuration,'percent----',percent,'params.watchPercent----',params.watchPercent)
                                //当时间大于试看时间时
                                if(timeDisplay>tryTime){
                                    //停止
                                    video.pause(); 
                                    //试看结束弹框提示立即报名
                                    this.$emit('openIt')
                                }else{
                                    //定时器
                                    clearInterval(this.timer);
                                    this.timer = setInterval(()=>{
                                        timeDisplay = Math.floor(video.currentTime);
                                        // console.log('timeDisplay----',timeDisplay,'tryTime----',tryTime)
                                        if(timeDisplay>=tryTime){
                                            //关闭定时器
                                            video.pause(); 
                                            //清楚计时器
                                            clearInterval(this.timer);
                                            //试看结束弹框提示立即报名
                                            this.$emit('openIt')
                                        }
                                    },1000);
                                }
                            })
                            //进度条移动事件
                            video.addEventListener('seeking', () => {
                                //移动到大于10秒自动返回
                                if(video.currentTime>tryTime){
                                    //进度退回试看时间
                                    video.currentTime=tryTime;
                                    //试看结束弹框提示立即报名
                                    this.$emit('openIt')
                                }
                            })
                        }
                    })
                    this.player = player2;
            }else{
                const player = new Aliplayer({
                    id: 'J_prismPlayer'+this.idName,
                    width: '100%',
                    height: '600px',
                    autoplay: false,
                    // source,
                    // 下方是音频视频安全的版本
                    vid: source.videoMeta.videoId,
                    playauth: source.playAuth,
                    cover: source.videoMeta.coverURL,
                    qualitySort: 'asc',// 指定排序方式，只有使用vid + plauth播放方式时支持 asc：示按正序排序（即：从小到大排序） 默认值：asc，仅H5支持。
                    // format: params.format,
                    mediaType: params.mediaType,
                    vodType: '1',
                    type: '1',//音频1  视频空
                    encryptType: 1,// 加密类型，播放点播私有加密视频时，默认值为0，取值：0~1。
                    isLive: false,
                    rePlay: false,// 播放器自动循环播放
                    playsinline: true,// H5是否内置播放，有的Android浏览器不起作用。
                    preload: false,
                    controlBarVisibility: 'hover',// 控制面板的实现，默认为值为：hover。click：点击 hover：停留 always
                    useH5Prism: true,
                    // skinLayout 功能组件布局配置，不传该字段使用默认布局
                    skinLayout: [
                        {
                            name: "bigPlayButton",
                            align: "cc",
                            x: 0,
                            y: 0
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            children: [
                                {
                                    name: "progress",
                                    align: "blabs",
                                    x: 0,
                                    y: 44
                                },
                                {
                                    name: "playButton",
                                    align: "tl",
                                    x: 15,
                                    y: 12
                                },
                                {
                                    name: "timeDisplay",
                                    align: "tl",
                                    x: 10,
                                    y: 7
                                },
                                {
                                    name: "fullScreenButton",
                                    align: "tr",
                                    x: 10,
                                    y: 12
                                },
                                {
                                    name: "volume",
                                    align: "tr",
                                    x: 5,
                                    y: 10
                                }
                            ]
                        }
                    ]
                },
                player => {
                        console.log("音频播放器创建了", player);
                        //判断视频和音频获取对应标签
                        if(!this.isOrder){
                            if(params.format=='mp3'){
                                var video = document.getElementById('J_prismPlayer'+this.idName).getElementsByTagName('audio')[0]
                            }else{
                                var video = document.getElementById('J_prismPlayer'+this.idName).getElementsByTagName('video')[0]
                            }
                            // console.log(video)
                            var timeDisplay
                            var tryTime
                            var percent
                            //点击开始事件
                            video.addEventListener('play', ()=> {
                                //获取当前播放的时间指针
                                timeDisplay = Math.floor(video.currentTime);
                                //试看百分比
                                percent = parseFloat(params.watchPercent/100);
                                //可试看时间
                                tryTime = parseInt(this.player._vodDuration*percent)
                                // console.log('timeDisplay----',timeDisplay,'tryTime----',tryTime,'this.player._vodDuration----',this.player._vodDuration,'percent----',percent,'params.watchPercent----',params.watchPercent)
                                //当时间大于试看时间时
                                if(timeDisplay>tryTime){
                                    //停止
                                    video.pause(); 
                                    //试看结束弹框提示立即报名
                                    this.$emit('openIt')
                                }else{
                                    //定时器
                                    clearInterval(this.timer);
                                    this.timer = setInterval(()=>{
                                        timeDisplay = Math.floor(video.currentTime);
                                        // console.log('timeDisplay----',timeDisplay,'tryTime----',tryTime)
                                        if(timeDisplay>=tryTime){
                                            //关闭定时器
                                            video.pause(); 
                                            //清楚计时器
                                            clearInterval(this.timer);
                                            //试看结束弹框提示立即报名
                                            this.$emit('openIt')
                                        }
                                    },1000);
                                }
                            })
                            //进度条移动事件
                            video.addEventListener('seeking', () => {
                                //移动到大于10秒自动返回
                                if(video.currentTime>tryTime){
                                    //进度退回试看时间
                                    video.currentTime=tryTime;
                                    //试看结束弹框提示立即报名
                                    this.$emit('openIt')
                                }
                            })
                        }
                    }
                );
                this.player = player;
            }
        },
    }
};
</script>

<style scoped></style>
